import request from '@/utils/request'
import axiosRequest from '@/utils/axiosRequest'
import qs from 'qs'
// import axios from 'axios'

export function logout() {
    return request({
        baseURL: '/auth',
        url: '/realms/' + process.env.VUE_APP_KC_REALM + '/protocol/openid-connect/logout',
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        data: qs.stringify({
            'client_id': process.env.VUE_APP_KC_CLIENT_ID,
            'refresh_token': localStorage.getItem('refreshToken') || ''
        })
    })
}

export function update(data) {
  return request({
    url: 'admin/sys/user/updatePassword',
    method: 'post',
    data
  })
}

//KeyCloak 免登陆
export function getTokenByketCloak(data) {
  return axiosRequest({
    baseURL: process.env.VUE_APP_KC_AUTH_URL,
    url: '/realms/org-iservice-yt/protocol/openid-connect/token',
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify({
      'client_id': process.env.VUE_APP_KC_CLIENT_ID,
      'username': data.username,
      'password': data.password,
      'grant_type': 'password',
  })
  })  
}
